<main
  class="flex h-full grow flex-col p-4 md:p-6 lg:p-8 mt-8 bg-background-light dark:bg-background-dark"
>
  <!-- Header -->
  <header class="mb-6 flex flex-wrap items-center justify-between gap-4">
    <div class="flex flex-col">
      <h1
        class="text-3xl font-black leading-tight tracking-tight text-text-primary dark:text-white"
      >
        Masters
      </h1>
    </div>
    <div class="flex items-center gap-2">
      <button
        class="flex h-10 items-center justify-center gap-2 rounded-lg bg-primary px-4 text-sm font-bold text-white hover:bg-primary/90"
        (click)="openProductModal()"
      >
        <span class="material-symbols-outlined text-lg">add</span>
        <span>Add Project</span>
      </button>
      <button
        class="flex h-10 items-center justify-center gap-2 rounded-lg bg-accent px-4 text-sm font-bold text-white hover:bg-accent/90"
        (click)="openModuleModal()"
      >
        <span class="material-symbols-outlined text-lg">add</span>
        <span>Add Module</span>
      </button>
    </div>
  </header>

  <!-- Grid -->
  <div class="grid flex-1 grid-cols-1 gap-6 md:grid-cols-3 lg:grid-cols-12">
    <!-- Product List -->
    <div
      class="flex flex-col gap-4 rounded-xl bg-card-background p-4 shadow-md dark:bg-card-background-dark md:col-span-1 lg:col-span-4"
    >
      <h2 class="text-xl font-bold text-text-primary dark:text-white">Projects</h2>

      <div class="flex flex-col gap-2">
        <div
          *ngFor="let product of products; let i = index"
          class="group relative flex cursor-pointer items-center justify-between gap-4 rounded-md p-3 transition-all hover:bg-gray-50 dark:hover:bg-white/5"
          [ngClass]="{
            'bg-primary/10 ring-2 ring-primary dark:bg-primary/20':
              selectedProductIndex === i
          }"
          (click)="selectProduct(i)"
        >
          <div class="flex min-w-0 items-center gap-3">
            <div
              class="flex size-10 shrink-0 items-center justify-center rounded-lg"
              [ngClass]="
                selectedProductIndex === i
                  ? 'bg-primary text-white'
                  : 'bg-gray-100 text-gray-400 dark:bg-gray-700 dark:text-gray-300'
              "
            >
              <!-- <span class="material-symbols-outlined">{{ product.icon }}</span> -->
              <span class="text-lg font-medium">
                {{ product.name | initials }}
              </span>
            </div>
            <p
              class="flex-1 truncate text-base font-medium"
              [ngClass]="
                selectedProductIndex === i
                  ? 'text-primary dark:text-white'
                  : 'text-text-primary dark:text-gray-200'
              "
            >
              {{ product.name }}
            </p>
          </div>

          <!-- Edit/Delete (visible on hover) -->
          <div
            class="absolute right-3 flex gap-2 opacity-0 transition-opacity duration-200 group-hover:opacity-100"
          >
            <button
              class="p-1.5 rounded-full hover:bg-blue-100 text-blue-600 dark:hover:bg-blue-900/50"
              (click)="openProductModal(i); $event.stopPropagation()"
            >
              <span class="material-symbols-outlined text-base">edit</span>
            </button>
            <button
              class="p-1.5 rounded-full hover:bg-red-100 text-red-600 dark:hover:bg-red-900/50"
              (click)="deleteProduct(i); $event.stopPropagation()"
            >
              <span class="material-symbols-outlined text-base">delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Module List -->
    <div
      class="flex flex-col gap-4 rounded-xl bg-card-background p-4 shadow-md dark:bg-card-background-dark md:col-span-2 lg:col-span-8"
      *ngIf="selectedProductIndex !== null"
    >
      <h2 class="text-xl font-bold text-text-primary dark:text-white">
        Modules for
        <span class="text-primary">{{ products[selectedProductIndex].name }}</span>
      </h2>

      <!-- Product Description -->
      <p class="text-gray-500 dark:text-gray-400 -mt-2 mb-2">
        {{ products[selectedProductIndex].description }}
      </p>

      <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        <div
          *ngFor="let module of products[selectedProductIndex].modules; let mi = index"
          class="group relative flex min-h-[64px] items-center justify-between rounded-md border border-gray-300 p-4 transition-all hover:shadow-md dark:border-gray-700 dark:hover:border-primary"
        >
          <p class="font-medium text-text-primary dark:text-gray-200">
            {{ module.moduleName }}
          </p>
          <div
            class="absolute right-2 top-1/2 -translate-y-1/2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
          >
            <button
              class="rounded-full p-1.5 text-blue-600 hover:bg-blue-100 dark:hover:bg-blue-900/50"
              (click)="openModuleModal(mi)"
            >
              <span class="material-symbols-outlined text-lg">edit</span>
            </button>
            <button
              class="rounded-full p-1.5 text-red-600 hover:bg-red-100 dark:hover:bg-red-900/50"
              (click)="deleteModule(mi)"
            >
              <span class="material-symbols-outlined text-lg">delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Product Modal -->
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
    *ngIf="showProductModal"
  >
    <div
      class="w-full max-w-md rounded-lg bg-background-light p-6 shadow-xl dark:bg-card-background-dark"
    >
      <h3 class="text-xl font-bold text-text-primary dark:text-white">
        {{ editIndex !== null ? 'Edit Project' : 'Create New Project' }}
      </h3>

      <div class="mt-4">
        <label
          for="product-name"
          class="text-sm font-medium text-text-primary dark:text-gray-300"
        >
          Project Name
        </label>
        <input
          id="product-name"
          type="text"
          [(ngModel)]="productName"
          class="form-input mt-1 block h-10 w-full rounded-md border border-gray-300 bg-background-light focus:border-primary focus:ring-primary dark:border-gray-600 dark:bg-background-dark dark:text-white px-2"
        />
      </div>

      <div class="mt-4">
        <label
          for="product-desc"
          class="text-sm font-medium text-text-primary dark:text-gray-300"
        >
          Project Description
        </label>
        <textarea
          id="product-desc"
          rows="3"
          [(ngModel)]="productDescription"
          class="form-input mt-1 block w-full rounded-md border border-gray-300 bg-background-light focus:border-primary focus:ring-primary dark:border-gray-600 dark:bg-background-dark dark:text-white px-2"
        ></textarea>
      </div>

      <div class="mt-6 flex justify-end gap-3">
        <button
          class="rounded-md px-4 py-2 text-sm font-bold text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
          (click)="closeProductModal()"
        >
          Cancel
        </button>
        <button
          class="rounded-md bg-primary px-4 py-2 text-sm font-bold text-white hover:bg-primary/90 cursor-pointer"
          (click)="saveProduct()"
        >
          Save
        </button>
      </div>
    </div>
  </div>

  <!-- Module Modal -->
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
    *ngIf="showModuleModal"
  >
    <div
      class="w-full max-w-md rounded-lg bg-background-light p-6 shadow-xl dark:bg-card-background-dark"
    >
      <h3 class="text-xl font-bold text-text-primary dark:text-white">
        {{ editModuleIndex !== null ? 'Edit Module' : 'Create New Module' }}
      </h3>

      <div class="mt-4">
        <label
          for="module-product"
          class="text-sm font-medium text-text-primary dark:text-gray-300"
        >
          Select Project
        </label>
        <select
          id="module-product"
          [(ngModel)]="selectedProductForModule"
          class="mt-1 block h-10 w-full rounded-md border border-gray-300 bg-background-light focus:border-primary focus:ring-primary dark:border-gray-600 dark:bg-background-dark dark:text-white px-1"
        >
          <option *ngFor="let p of products" [value]="p.name">{{ p.name }}</option>
        </select>
      </div>

      <div class="mt-4">
        <label
          for="module-name"
          class="text-sm font-medium text-text-primary dark:text-gray-300"
        >
          Module Name
        </label>
        <input
          id="module-name"
          type="text"
          [(ngModel)]="moduleName"
          class="form-input mt-1 block h-10 w-full rounded-md border border-gray-300 bg-background-light focus:border-primary focus:ring-primary dark:border-gray-600 dark:bg-background-dark dark:text-white px-2"
        />
      </div>

      <div class="mt-6 flex justify-end gap-3">
        <button
          class="rounded-md px-4 py-2 text-sm font-bold text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
          (click)="closeModuleModal()"
        >
          Cancel
        </button>
        <button
          class="rounded-md bg-primary px-4 py-2 text-sm font-bold text-white hover:bg-primary/90 cursor-pointer"
          (click)="saveModule()"
        >
          Save
        </button>
      </div>
    </div>
  </div>

  <!-- confirm -->
   <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
    *ngIf="showDeleteModal"
  >
    <div
      class="w-full max-w-sm rounded-lg bg-background-light p-6 shadow-xl dark:bg-card-background-dark text-center"
    >
      <span class="material-symbols-outlined text-red-600 text-5xl mb-3">warning</span>
      <h3 class="text-xl font-bold text-text-primary dark:text-white mb-2">
        Confirm Delete
      </h3>
      <p class="text-gray-600 dark:text-gray-400 mb-6">
        Are you sure you want to delete this
        <span class="font-semibold text-primary">{{ deleteType }}</span>? This action
        cannot be undone.
      </p>

      <div class="flex justify-center gap-4">
        <button
          class="rounded-md px-4 py-2 text-sm font-bold text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
          (click)="closeDeleteModal()"
        >
          Cancel
        </button>
        <button
          class="rounded-md bg-red-600 px-4 py-2 text-sm font-bold text-white hover:bg-red-700"
          (click)="confirmDelete()"
        >
          Delete
        </button>
      </div>
    </div>
  </div>

  <!-- Toast -->
  <div
    class="fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-md bg-green-600 px-4 py-3 text-white shadow-lg transition-all duration-300"
    [ngClass]="{
      'translate-y-0 opacity-100': showToast,
      'translate-y-20 opacity-0': !showToast
    }"
  >
    <span class="material-symbols-outlined">check_circle</span>
    <p class="text-sm font-semibold">{{ toastMessage }}</p>
  </div>
</main>
